import { Injectable } from '@angular/core';
import { Router } from '@angular/router';


@Injectable()
export class AuthService {

    constructor(private myRoute: Router) { }

    getToken() {
        return localStorage.getItem("member-id")
    }
    isLoggednIn() {
        return this.getToken() !== null;
    }

    getpayment() {
        return localStorage.getItem("onlinepayment");
    }
    ispaymentactive() {
        return this.getpayment() !== null;
    }

}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts